export default {
  data: {
    updataPriceType: "",
    updataPriceKind100: "",
    updataPriceKind200: "",
    updataPriceKind300: ""
  },
  //type(Reg正则验证,Empty验证为空,MinMax验证数量区间)
  rule: {
    updataPriceType: {
      type: "id",
      message: "请选择改价方式",
    },
    updataPriceKind100: {
      type: "id",
      message: "发明专利加价数据不合法，必须是大于0的整数",
    },
    updataPriceKind200: {
      type: "id",
      message: "新型实用加价数据不合法，必须是大于0的整数",
    },
    updataPriceKind300: {
      type: "id",
      message: "外观设计加价数据不合法，必须是大于0的整数",
    }
  },
};
